import { BaseFilterDto } from "@/dto/BaseFilterDto.ts";

/**
 * 선택 보고서 변환 - req
 * */
export class CreateDocumentWithIdsReqDto {
    inspectionIds: bigint[];
}

/**
 * 특정 보고서 변환 - req
 * */
export class CreateDocumentWithFilterReqDto extends BaseFilterDto {}

/**
 * 환경부 제출용 엑셀 - req
 * */
export class CreateKecoExcelReqDto extends BaseFilterDto {}

/**
 * 보고서 & 엑셀 공통 - res
 * */
export class CreateDocumentResDto {
    presignedUrl: string;
}
